import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { TeacherProfileValues, myTeacherProfileApi } from '@/services/api/profile/profile';

export const myTeacherProfileKeys = {
  mine: ['me', 'teacher-profile'] as const,
};

export function useMyTeacherProfileQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: myTeacherProfileKeys.mine,
    queryFn: () => myTeacherProfileApi.get(),
    enabled: options?.enabled ?? true,
  });
}

export function useSubmitMyTeacherProfileMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: TeacherProfileValues) => myTeacherProfileApi.submit(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: myTeacherProfileKeys.mine });
      // The admin's pending count and review queue both move when this lands.
      void queryClient.invalidateQueries({ queryKey: ['admin', 'teachers'] });
    },
  });
}
